.title {
  margin: 0px 0px 15px 0px;
}

.secondary-header {
  display: flex;
  align-items: center;
  gap: 5px;
}

.secondary-header h4 {
  margin: 0px 0px 5px 0px;
}

.secondary-header .icon {
  font-size: 20px;
  color: var(--button-primary-color);
}
